import { Link } from 'react-router';

/** Destination interne explicite : fonctionne aussi après une ouverture directe. */
export function RetourPage({
  vers = '/',
  libelle = 'Retour à l’accueil',
}: {
  vers?: string;
  libelle?: string;
}) {
  return (
    <p style={{ margin: '0 0 16px' }}>
      <Link
        to={vers}
        style={{ display: 'inline-flex', alignItems: 'center', minHeight: 44, gap: 8 }}
      >
        <span aria-hidden="true">←</span>
        {libelle}
      </Link>
    </p>
  );
}
